export enum EmployeeGroupActions {
    None = 0,
    EmployeeMigration = 1,
    EmployeeDelete = 2
}